import { type ReactNode, useEffect, useRef } from "react";
import { isWeb, type TamaguiElement, usePresence } from "tamagui";
import { YStack, type YStackProps } from "../Stacks";
export type PresenceSlotProps = Pick<YStackProps, "opacity" | "enterStyle" | "exitStyle" | "transition" | "animateOnly"> & {
  /** Fill the parent, for a slot inside a flex row or column. */
  flex?: boolean;
  children: ReactNode;
};

// An AnimatePresence child. The present one sits in normal flow so an
// auto-height layout grows with it; only a leaving one goes absolute, over the
// arriving one, and out of the tap and Tab order until its exit ends. The slot
// owns the layout props and the frame inside it only animates: on native a
// layout prop on the animated node lands a frame late, so layout props stay
// off it.
export const PresenceSlot = ({
  flex,
  children,
  ...frame
}: PresenceSlotProps) => {
  const [isPresent] = usePresence();
  const ref = useRef<TamaguiElement>(null);
  useEffect(() => {
    if (isWeb && ref.current instanceof HTMLElement) {
      ref.current.toggleAttribute("inert", !isPresent);
    }
  }, [isPresent]);
  return <YStack ref={ref} pointerEvents={isPresent ? "auto" : "none"} position={isPresent ? "relative" : "absolute"} flex={flex && isPresent ? 1 : undefined} top={0} left={0} right={0} bottom={0} width="100%" data-sentry-element="YStack" data-sentry-component="PresenceSlot" data-sentry-source-file="PresenceSlot.tsx">
      <YStack flex={flex ? 1 : undefined} {...frame} data-sentry-element="YStack" data-sentry-source-file="PresenceSlot.tsx">
        {children}
      </YStack>
    </YStack>;
};